import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environment";
import { Observable, map } from "rxjs";

@Injectable({ providedIn: "root" })
export class UserEsignatureClient {
  private readonly endpoint = "useresignature";

  constructor(private httpClient: HttpClient) {}

  isEsignatureRequired(): Observable<{ isEsignatureRequired: boolean; isPhysician: boolean;isEsignEnabled:boolean }> {
    return this.httpClient
      .post<{ isEsignatureRequired: boolean; isPhysician: boolean;isEsignEnabled:boolean }>(
        `${environment.endpoint}/${this.endpoint}/isesingnaturesetuprequired`,
        {}
      )
      .pipe(
        map((res: { isEsignatureRequired: boolean; isPhysician: boolean;isEsignEnabled:boolean }) => ({
          isEsignatureRequired: res.isEsignatureRequired,
          isPhysician: res.isPhysician,
          isEsignEnabled: res.isEsignEnabled,
        }))
      );
  }

  updateNPIData() {
    return this.httpClient
      .post(
        `${environment.endpoint}/${this.endpoint}/update-npi-data`,
        {}
      )
  }

  declineNPIData(): Observable<string> {
    return this.httpClient
      .post<{ responseMessage: string }>(
        `${environment.endpoint}/${this.endpoint}/decline-npi-data`,
        {}
      )
      .pipe(map((res: {responseMessage: string}) => (res?.responseMessage)))
  }

  createOrUpdateESignature(
    esignature: string,
    confirmEsignature: string,
    esignaturepin?: string,
    confirmesignaturepin?: string,
    sendallrequests?: boolean,
    sendemaildaily?: boolean,
    dailyruntime?: number,
    dailyam?: boolean,
    sendemailweekly?: boolean,
    weeklyruntime?: number,
    weeklyam?: boolean,
    dayofweek?: number
  ): Observable<any> {
    return this.httpClient.post(
      `${environment.endpoint}/${this.endpoint}/CreateOrUpdateESignature`,
      { 
        esignature: esignature, confirmEsignature, 
        esignaturepin: esignaturepin,
        confirmesignaturepin: confirmesignaturepin,
        sendallrequests:sendallrequests,
        sendemaildaily: sendemaildaily,
        dailyruntime: dailyruntime,
        dailyam: dailyam,
        sendemailweekly: sendemailweekly,
        weeklyruntime: weeklyruntime,
        weeklyam: weeklyam, 
        dayofweek:dayofweek 
      }
    );
  }
}
